import React from 'react'

import clsx from 'clsx'

import { Button, EnumButtonVariants } from '@insquad/tools'

import { BlogCard } from 'src/common/components/BlogCard/BlogCard'
import { ArticleClientType } from 'src/strapi/types/articleTypes'

import s from './BlogCardsBlock.module.scss'

export type BlogCardsBlockProps = {
  articles: Array<ArticleClientType>
  hasNextPage: boolean
  onLoadMore: () => void
}

export const BlogCardsBlock: React.FC<BlogCardsBlockProps> = ({
  articles,
  hasNextPage,
  onLoadMore,
}) => (
  <section className={clsx(s.BlogCardsBlock, 'container')}>
    <div className={s.BlogCardsBlock__inner}>
      {articles.map((articles, i) => (
        <BlogCard key={i} {...articles} />
      ))}
    </div>

    {hasNextPage && (
      <Button
        onClick={onLoadMore}
        className={s.BlogCardsBlock__btn}
        variant={EnumButtonVariants.SECONDARY}
      >
        Load more
      </Button>
    )}
  </section>
)
